export default {
  MEMBER: `${process.env.REACT_APP_API_ENDPOINT}/Members`,
  COMMAND: `${process.env.REACT_APP_API_ENDPOINT}/Commands`,
  DEVICE: `${process.env.REACT_APP_API_ENDPOINT}/Devices`,
};
